import { render, staticRenderFns } from "./CommonSendCode.vue?vue&type=template&id=d605f42a&scoped=true"
import script from "./CommonSendCode.vue?vue&type=script&lang=js"
export * from "./CommonSendCode.vue?vue&type=script&lang=js"
import style0 from "./CommonSendCode.vue?vue&type=style&index=0&id=d605f42a&prod&lang=scss&scoped=true"
import style1 from "./CommonSendCode.vue?vue&type=style&index=1&id=d605f42a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d605f42a",
  null
  
)

export default component.exports